export default __webpack_public_path__ + "static/media/182w.cfa22f01.svg";